import React from "react";
import {FiEdit2, FiAirplay, FiCreditCard, FiGlobe, FiLayout,FiLifeBuoy} from "../assets/icons/vander"
export default function AiFeatures(){
    const featureData = [
        {
            icon:FiEdit2,
            title:'Desenvolvimento Customizado',
            desc:'Software personalizados e inovadores utilizando as melhores práticas e metodologias ágeis.'
        },
        {
            icon:FiAirplay,
            title:'Desenvolvimento de API',
            desc:'Desenvolvimento de API\'s de alta performance que são fáceis de consumir, escaláveis e seguras.'
        },
        {
            icon:FiLifeBuoy,
            title:'Desenvolvimento de Aplicativos',
            desc:'Oferecemos uma experiência de usuário de ponta, intuitiva e com recursos poderosos.'
        },
        {
            icon:FiGlobe,
            title:'DevOps',
            desc:'Encurtamos o ciclo de desenvolvimento ágil de software, entregas contínuas e automatizadas.'
        },
        {
            icon:FiLayout,
            title:'UX & UI Design',
            desc:'Criamos e desenvolvemos experiências únicas, modernas e inovadoras'
        },
        {
            icon:FiLifeBuoy,
            title:'Social Media',
            desc:'Contamos também com um time especialido em redes sociais, para alavancar sua empresa nas redes!'
        },
    ]
    return(
        <>
        <div className="container relative md:mt-24 mt-16">
                <div className="grid grid-cols-1 pb-6 text-center">
                    <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">O que fazemos?</h3>

                    <p className="text-slate-400 max-w-xl mx-auto">Com a Hope, sua empresa conta com profissionais altamente capacitados para apoiar o desenvolvimento de soluções digitais de alta performance. </p>
                </div>

                <div className="grid md:grid-cols-3 grid-cols-1 mt-6 gap-6">
                    {featureData.map((item,index)=>{
                        const Icon = item.icon
                        return(
                            <div className="group flex duration-500 xl:p-3" key={index}>
                                <div className="flex align-middle justify-center items-center w-14 h-14 mt-1 bg-amber-400/5 group-hover:bg-amber-400 group-hover:text-white border-2 border-amber-400/20 text-amber-400 rounded-lg text-2xl shadow-sm dark:shadow-gray-800 duration-500">
                                    <Icon className="w-5 h-5"/>
                                </div>
                                <div className="flex-1 ms-4">
                                    <h4 className="mb-0 text-lg font-semibold">{item.title}</h4>
                                    <p className="text-slate-400 mt-2">{item.desc}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}
